import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { DvirHistoryState } from '../types';
import { dvirHistoryState } from './dvirHistoryState';

export const dvirHistorySlice = createSlice({
  name: 'dvirHistory',
  initialState: dvirHistoryState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setDataReset(state) {
      state = dvirHistoryState;
    },
    setDvir(state, action: PayloadAction<DvirHistoryState['dvir']>) {
      state.dvir = action.payload;
    },
    setDvirUpdateDetails(
      state,
      action: PayloadAction<DvirHistoryState['dvirUpdateDetails']>,
    ) {
      state.dvirUpdateDetails = action.payload;
    },
    setEquipments(
      state,
      action: PayloadAction<DvirHistoryState['equipments']>,
    ) {
      state.equipments = action.payload;
    },
    setDriver(state, action: PayloadAction<DvirHistoryState['driver']>) {
      state.driver = action.payload;
    },
    setTerminal(state, action: PayloadAction<DvirHistoryState['terminal']>) {
      state.terminal = action.payload;
    },
    setSeverity(state, action: PayloadAction<DvirHistoryState['severity']>) {
      state.severity = action.payload;
    },
    setDateRange(state, action: PayloadAction<DvirHistoryState['dateRange']>) {
      state.dateRange = action.payload;
    },
    setSortBy(state, action: PayloadAction<DvirHistoryState['sortBy']>) {
      state.sortBy = action.payload;
    },
    setSortField(state, action: PayloadAction<DvirHistoryState['sortField']>) {
      state.sortField = action.payload;
    },
    setRowsPerPage(state, action: PayloadAction<number>) {
      state.limit = action.payload;
    },
    setPageIndex(state, action: PayloadAction<number>) {
      state.offset = action.payload;
    },
    setTotalRecordCounts(state, action: PayloadAction<number>) {
      state.totalRecordCount = action.payload;
    },
    setBase64StringMedia(
      state,
      action: PayloadAction<DvirHistoryState['base64stringMedia']>,
    ) {
      state.base64stringMedia = action.payload;
    },
    setToggleCertifyDvirModal(state, action: PayloadAction<boolean>) {
      state.isToggleCertifyDvirModal = action.payload;
    },
    setToggleUpdateDetailsModal(state, action: PayloadAction<boolean>) {
      state.isToggleUpdateDetailsModal = action.payload;
    },
    setToggleMechanicSignatureModal(state, action: PayloadAction<boolean>) {
      state.isToggleMechanicSignatureModal = action.payload;
    },
    setResetData: () => dvirHistoryState,
    setVehicleFilterMenuClosed(state, action: PayloadAction<boolean>) {
      state.isVehicleFilterMenuClosed = action.payload;
    },
  },

});

/* ------- ACTION CREATORS ------- */
export const { actions: dvirHistoryActions } = dvirHistorySlice;

/* ------- STATE SELECTORS ------- */
export const selectDvirHistory = (state: RootState) => state.dvirHistory;

export default dvirHistorySlice.reducer;
